import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

const reviews = [
  {
    id: 1,
    name: '吃瓜群众A',
    content: '一直都在黑料吃瓜网追最新的爆料，更新速度真的快，画质也很清晰，强烈推荐！',
    rating: 5,
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '娱乐达人B',
    content: '全网最全的吃瓜资源都在这里了，分类很清晰，找内容特别方便。一区二区的内容尤其精彩。',
    rating: 5,
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '追剧小能手',
    content: '即点即播真的很方便，不用下载就能看高清视频，节省了好多手机空间。',
    rating: 4,
    date: '2026-07-22',
  },
  {
    id: 4,
    name: '八卦研究员',
    content: '在这个网站追了两年瓜了，信息可靠度高，很多独家内容都是最先在这里看到的。',
    rating: 5,
    date: '2026-07-20',
  },
  {
    id: 5,
    name: '资深瓜友',
    content: '页面设计简洁大方，播放流畅不卡顿。在线观看体验非常棒，一直在推荐给朋友。',
    rating: 5,
    date: '2026-07-18',
  },
  {
    id: 6,
    name: '夜猫子小分队',
    content: '晚上睡不着的时候就打开黑料吃瓜网看看最新爆料，内容更新很及时，永远不怕瓜不够吃。',
    rating: 4,
    date: '2026-07-15',
  },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 黑料吃瓜网 | 品牌介绍 用户口碑 联系方式';
  }, []);

  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const formData = new FormData(form);
      const submitAddr = 'https://readdy.ai/api/form/d9optrosenbniolesjl0';

      const response = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const errorMsg = parsed?.meta?.message || parsed?.message || responseText || '提交失败，请稍后重试';
        setFormError(errorMsg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 黑料吃瓜网',
    description: '了解黑料吃瓜网品牌故事、用户口碑评价及联系方式',
    url: 'https://heiliaochigua.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料吃瓜网',
      url: 'https://heiliaochigua.com',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '黑料吃瓜网是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '黑料吃瓜网是一个免费高清完整视频在线播放平台，提供一区二区、在线观看、站在线观看等分区的最新爆料吃瓜内容，即点即播无需下载。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在黑料吃瓜网观看视频？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '直接访问黑料吃瓜网，通过首页分类导航选择感兴趣的分区（如一区二区、在线观看、站在线观看等），点击文章即可在线观看完整视频内容，无需注册或下载任何软件。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料吃瓜网的内容是否免费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，黑料吃瓜网上所有内容均免费提供，用户无需支付任何费用即可畅享高清完整视频资源。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料吃瓜网的播放画质如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '黑料吃瓜网提供高清画质的视频资源，支持流畅在线播放，确保用户获得最佳的观看体验。',
        },
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <Navbar />
      <main>
        <section className="bg-background-900 relative overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20elegant%20abstract%20background%20with%20soft%20amber%20and%20crimson%20accents%20floating%20gentle%20light%20particles%20professional%20atmosphere%20clean%20minimal%20editorial%20quality&width=1600&height=300&seq=about-header-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover opacity-30"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-background-900"></div>
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-12">
            <div className="mb-4">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '关于我们' },
                ]}
              />
            </div>
            <h1 className="font-heading text-3xl text-white mb-2">关于我们</h1>
            <p className="text-white/70 text-sm">了解黑料吃瓜网的品牌故事与使命</p>
          </div>
        </section>

        <section className="max-w-4xl mx-auto px-4 md:px-6 py-12">
          <div className="space-y-12">
            <div>
              <h2 className="font-heading text-2xl text-foreground-950 mb-4">品牌介绍</h2>
              <div className="prose max-w-none">
                <p className="text-foreground-700 leading-relaxed mb-4">
                  黑料吃瓜网成立于2024年，是国内领先的娱乐资讯和吃瓜内容聚合平台。我们致力于为用户提供<strong>最新、最全、最高清</strong>的爆料吃瓜内容，涵盖一区二区、在线观看、站在线观看等多个分区，满足不同用户的观看需求。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  平台汇集了来自全网的海量娱乐八卦、社会热点、明星动态等精彩内容，通过智能推荐算法为用户精准推送感兴趣的资讯。我们秉持<strong>"即点即播、无需下载"</strong>的产品理念，让用户在任何设备上都能获得流畅的观看体验。
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  黑料吃瓜网拥有一支专业的内容运营团队，7×24小时不间断更新，确保用户永远能吃到最新鲜的"瓜"。我们严格把控内容质量，所有视频均采用高清画质，让每一帧画面都清晰呈现。
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-eye-line w-7 h-7 flex items-center justify-center text-primary-500"></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-950 mb-2">海量内容</h3>
                <p className="text-sm text-foreground-600">覆盖六大分区，每日更新最新爆料，总有一款适合你</p>
              </div>
              <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-flashlight-line w-7 h-7 flex items-center justify-center text-accent-500"></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-950 mb-2">即点即播</h3>
                <p className="text-sm text-foreground-600">无需下载任何软件，打开网页即可流畅观看高清视频</p>
              </div>
              <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 text-center">
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line w-7 h-7 flex items-center justify-center text-secondary-500"></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-950 mb-2">安全可靠</h3>
                <p className="text-sm text-foreground-600">严格内容审核机制，保障用户信息安全，放心浏览</p>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl text-foreground-950 mb-6">用户口碑</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {reviews.map((review) => (
                  <div key={review.id} className="bg-background-50 rounded-xl border border-background-200/70 p-5">
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                        <span className="text-xs font-bold text-primary-600">{review.name.charAt(0)}</span>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                        <p className="text-xs text-foreground-500">{review.date}</p>
                      </div>
                    </div>
                    <div className="flex gap-0.5 mb-2">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill w-3.5 h-3.5 flex items-center justify-center text-accent-500"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">{review.content}</p>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl text-foreground-950 mb-4">常见问题</h2>
              <div className="space-y-4">
                {[
                  { q: '黑料吃瓜网是什么？', a: '黑料吃瓜网是一个免费高清完整视频在线播放平台，提供一区二区、在线观看、站在线观看等分区的最新爆料吃瓜内容，即点即播无需下载。' },
                  { q: '如何在黑料吃瓜网观看视频？', a: '直接访问黑料吃瓜网，通过首页分类导航选择感兴趣的分区（如一区二区、在线观看、站在线观看等），点击文章即可在线观看完整视频内容，无需注册或下载任何软件。' },
                  { q: '黑料吃瓜网的内容是否免费？', a: '是的，黑料吃瓜网上所有内容均免费提供，用户无需支付任何费用即可畅享高清完整视频资源。' },
                  { q: '黑料吃瓜网的播放画质如何？', a: '黑料吃瓜网提供高清画质的视频资源，支持流畅在线播放，确保用户获得最佳的观看体验。' },
                ].map((faq, i) => (
                  <details key={i} className="bg-background-50 rounded-xl border border-background-200/70 p-5 group cursor-pointer">
                    <summary className="font-heading text-foreground-950 text-base cursor-pointer list-none flex items-center justify-between">
                      {faq.q}
                      <i className="ri-add-line w-5 h-5 flex items-center justify-center text-foreground-400 group-open:hidden"></i>
                      <i className="ri-subtract-line w-5 h-5 flex items-center justify-center text-foreground-400 hidden group-open:flex"></i>
                    </summary>
                    <p className="mt-3 text-sm text-foreground-700 leading-relaxed">{faq.a}</p>
                  </details>
                ))}
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl text-foreground-950 mb-6">联系我们</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line w-5 h-5 flex items-center justify-center text-primary-500"></i>
                    </div>
                    <div>
                      <h4 className="font-heading text-sm text-foreground-950 mb-1">电子邮箱</h4>
                      <p className="text-sm text-foreground-600">contact@heiliaochigua.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-customer-service-2-line w-5 h-5 flex items-center justify-center text-accent-500"></i>
                    </div>
                    <div>
                      <h4 className="font-heading text-sm text-foreground-950 mb-1">在线客服</h4>
                      <p className="text-sm text-foreground-600">7×24小时在线服务，随时为您解答</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center text-secondary-500"></i>
                    </div>
                    <div>
                      <h4 className="font-heading text-sm text-foreground-950 mb-1">公司地址</h4>
                      <p className="text-sm text-foreground-600">中国北京市朝阳区互联网产业园区</p>
                    </div>
                  </div>
                </div>

                <div className="bg-background-50 rounded-xl border border-background-200/70 p-6">
                  <h3 className="font-heading text-base text-foreground-950 mb-4">发送消息</h3>
                  <form onSubmit={handleSubmit} data-readdy-form="">
                    <div className="honeypot-field">
                      <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                    </div>
                    <div className="space-y-3">
                      <input
                        type="text"
                        name="name"
                        placeholder="您的姓名"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-white text-sm text-foreground-700 placeholder-foreground-400 outline-none focus:border-primary-300 transition-colors duration-200"
                      />
                      <input
                        type="email"
                        name="email"
                        placeholder="您的邮箱"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-white text-sm text-foreground-700 placeholder-foreground-400 outline-none focus:border-primary-300 transition-colors duration-200"
                      />
                      <textarea
                        name="message"
                        placeholder="请输入您的留言内容..."
                        rows={4}
                        maxLength={500}
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-white text-sm text-foreground-700 placeholder-foreground-400 outline-none focus:border-primary-300 transition-colors duration-200 resize-none"
                      ></textarea>
                      <button
                        type="submit"
                        disabled={formStatus === 'loading'}
                        className="w-full py-2.5 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 disabled:opacity-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                      >
                        {formStatus === 'loading' ? '发送中...' : '发送消息'}
                      </button>
                    </div>
                    {formStatus === 'success' && (
                      <p className="mt-3 text-sm text-green-600">消息已发送成功，我们会尽快回复您！</p>
                    )}
                    {formStatus === 'error' && (
                      <p className="mt-3 text-sm text-red-600">{formError}</p>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}